/*
  mezuzi, theme 170.0 (#99) - the cart close button's hover = the source's.

  The source's close is `button--close is="hover-button"`: a brown fill (`.btn-fill`) rises from below on
  pointer enter and continues up on leave, 600 ms ease (theme.HoverButton). The fill code below is a COPY of
  hoverFill() in snippets/header-drawer.liquid (the menu drawer's Login + close, lines ~865-887; written in
  134.0 b802fa1c, bound to the menu close in 167.0 #85b) - change one, change the other. The cart's close
  comes from Tinker's shared theme-drawer-header snippet, so the fill span is inserted here, on the first
  pointerover, and only for the cart (#cart-drawer). The X turning 90deg and going white is CSS (base.css, #99).
  Source measured 12.10: review-168/d87/out/cartclose82.json.
*/

const BUTTON = '#cart-drawer .theme-drawer__close-button';
const ENTER_FROM = 'translate3d(0, 76%, 0)';
const REST = 'translate3d(0, 0, 0)';
const LEAVE_TO = 'translate3d(0, -76%, 0)';

/**
 * The fill span. A cart re-render morphs the drawer and drops the span (not in the server HTML) while keeping the button
 * node, so the span is looked up - and put back - at each event, and the listeners are bound once per node (a JS property,
 * which the morph does not touch; a data attribute was dropped with the span and bound a second set of listeners).
 * @param {HTMLElement} button
 */
function fillOf(button) {
  let fill = button.querySelector(':scope > .cart-drawer__close-fill');
  if (!fill) {
    fill = document.createElement('span');
    fill.className = 'cart-drawer__close-fill';
    fill.setAttribute('aria-hidden', 'true');
    button.prepend(fill);
  }
  return /** @type {HTMLElement} */ (fill);
}

/** @param {HTMLElement} button */
function bind(button) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  /** @param {string | null} from @param {string} to */
  const go = (from, to) => {
    const fill = fillOf(button);
    const start = from || getComputedStyle(fill).transform;
    for (const animation of fill.getAnimations()) animation.cancel();
    fill.animate([{ transform: start }, { transform: to }], { duration: reduced.matches ? 0 : 600, easing: 'ease', fill: 'forwards' });
  };
  button.addEventListener('pointerenter', (event) => {
    if (event.pointerType !== 'touch') go(ENTER_FROM, REST);
  });
  button.addEventListener('pointerleave', (event) => {
    if (event.pointerType !== 'touch') go(null, LEAVE_TO);
  });
}

document.addEventListener('pointerover', (event) => {
  const button = event.target instanceof Element ? /** @type {HTMLElement | null} */ (event.target.closest(BUTTON)) : null;
  if (!button || /** @type {any} */ (button).__cartCloseHover || !window.matchMedia('(any-hover: hover)').matches) return;
  /** @type {any} */ (button).__cartCloseHover = true;
  bind(button);
  if (event.pointerType !== 'touch') button.dispatchEvent(new PointerEvent('pointerenter', { pointerType: event.pointerType }));
});
